// extracted by mini-css-extract-plugin
export var phoneNumberInput = "_i4-0";